import script from "./LogonView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LogonView.vue?vue&type=script&setup=true&lang=ts"

import "./LogonView.vue?vue&type=style&index=0&id=2c3b991f&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c3b991f"]])

export default __exports__